module.exports = __webpack_public_path__ + "static/img/DAVID_BOON.f7fecf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DAVID_BOON.jpg
// module id = YoAs
// module chunks = 0